export function getPatternId(cid: number, index: number) {
  return `P-${cid}-${index}`;
}
